export default function PortalLoadingSkeleton({ label = "Loading secure portal…", cards = false }: { label?: string; cards?: boolean }) {
  return <div role="status" aria-live="polite" aria-busy="true" aria-label={label} className="min-h-[65vh] space-y-5">
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className="portal-card p-5 motion-safe:animate-pulse">
      <div className="h-7 w-56 max-w-full rounded bg-brand-dark/10" />
      <div className="mt-4 h-4 w-80 max-w-full rounded bg-brand-dark/5" />
      <div className="mt-5 flex gap-3">{[0, 1, 2].map(item => <div key={item} className="h-8 w-24 rounded-full bg-brand-dark/5" />)}</div>
    </div>
    <div aria-hidden="true" className={cards ? "space-y-4" : "grid gap-5 lg:grid-cols-[2fr_1fr]"}>
      {[0, 1, 2].map(item => <div key={item} className="portal-card min-h-40 p-5 motion-safe:animate-pulse">
        <div className="mb-6 h-5 w-40 rounded bg-brand-dark/10" />
        {[0, 1, 2].map(line => <div key={line} className="mt-4 h-4 w-full rounded bg-brand-dark/5 last:w-2/3" />)}
      </div>)}
    </div>
  </div>;
}
